export default "__VITE_ASSET__Co_Hgh4i__"